// Tab stays inside an open dialog or drawer (WEB-36: it left the modal for
// the page behind it). nextFocus is the rule, on the focusable elements in
// order; trapTab applies it to a key event within root.

// nextFocus: the index Tab (back: Shift+Tab) moves to from at, wrapping;
// -1 (focus is outside them) enters at the first, or the last going back.
export function nextFocus(count: number, at: number, back: boolean): number {
    if (count === 0) return -1
    if (at < 0) return back ? count - 1 : 0
    return (at + (back ? count - 1 : 1)) % count
}

const focusable =
    'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

// trapTab keeps a Tab key inside root; returns whether it moved the focus.
export function trapTab(e: KeyboardEvent, root: HTMLElement | null | undefined): boolean {
    if (e.key !== 'Tab' || !root) return false
    const els = [...root.querySelectorAll<HTMLElement>(focusable)].filter(
        (el) => el.offsetParent !== null || el === document.activeElement,
    )
    const i = nextFocus(els.length, els.indexOf(document.activeElement as HTMLElement), e.shiftKey)
    if (i < 0) return false
    e.preventDefault()
    els[i]!.focus()
    return true
}
